module.exports = __webpack_public_path__ + "static/media/400054_02.c35aed06.png";